import cn from 'classnames'
import useSticky, { StickyConfig } from './useSticky'
import styles from './Sticky.module.scss'

export interface StickyProps extends React.HTMLProps<HTMLDivElement> {
  config?: StickyConfig
  position?: 'top' | 'bottom'
  hasBgTransparent?: boolean
}

const Sticky = ({
  className,
  children,
  config,
  position = 'bottom',
  hasBgTransparent = false,
  ...props
}: StickyProps) => {
  const isSticky = useSticky(config)

  return (
    <div
      id='next-sticky-container'
      className={cn(
        position,
        styles.sticky,
        styles[position],
        {
          [styles.stickyActive]: isSticky,
          [styles[`${position}Bg`]]: !hasBgTransparent,
        },
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export default Sticky
